// ----------------------------------------------------------------------
// <copyright file="Izenda.RowSpanColumn.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var PropTypes = React.PropTypes;
  var RowSpanCell = require('./Izenda.RowSpanCell');
  var observer = require('mobx-react').observer;
  const { pick, map } = require('lodash/fp');
  // defer observer virtual list into smaller component
  var RowSpanCellVirtualList = observer(function(props) {
    var element = props.element;
    var init = props.init;
    var height = props.tableStore.getRowSpanHeight(init, element.size);
    var pickFn = pick(['fnGetCellStyle', 'fnGetCellContentStyle', 'cell'], props);

    return (
      <div className="table-row" style={{ height: height }}>
        <RowSpanCell rowSpan={element} height={height} {...pickFn} index={props.index} />
      </div>
    );
  });

  var RowSpanColumn = React.createClass({
    propTypes: {
      tableStore: PropTypes.object.isRequired,
      rowSpan: PropTypes.object.isRequired
    },
    render: function() {
      var props = this.props;
      var init = 0;
      var rowSPan = props.rowSpan;
      var rowSpanFn = pick(['fnGetCellStyle', 'fnGetCellContentStyle', 'cell'], rowSPan);
      var mapConvert = map.convert({ cap: false });

      return (
        <div className="table-body" style={{ width: props.width }}>
          {mapConvert(function(element, index) {
            var oldInit = init;

            init = init + element.size;
            return (
              <RowSpanCellVirtualList
                element={element}
                key={oldInit}
                index={index}
                init={oldInit}
                tableStore={props.tableStore}
                {...rowSpanFn}
              />
            );
          }, rowSPan.data)}
        </div>
      );
    }
  });

  module.exports = observer(RowSpanColumn);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/DataGrid/Izenda.RowSpanColumn.jsx